/**
 * 入住备注模块
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import ReserveRemarkInfo from '@/components/Reservation/RemarkInfo';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { handleRemarkInfoChange } from '@/redux/actions/reservation/checkIn';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkIn';

const stateSelector = (state: ReducerState) => {
  return state.remarkInfo;
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callRemarkChange: handleRemarkInfoChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { remark, checkInRemark, callRemarkChange } = props;

  // 修改预订备注
  const setReserveRemark: (value: string) => void = (value) => {
    callRemarkChange({
      remark: value,
    });
  };

  // 修改入住备注
  const setCheckInRemark: (value: string) => void = (value) => {
    callRemarkChange({
      checkInRemark: value,
    });
  };

  return (
    <div>
      <ReserveRemarkInfo
        title={intl.get('app_reservation_reserve_remark')}
        placeholder={intl.get('reservation_remark_reserve_placeholder')}
        value={remark}
        onChange={setReserveRemark}
      />
      <ReserveRemarkInfo
        title={intl.get('app_reservation_checkin_remark')}
        placeholder={intl.get('reservation_remark_checkin_placeholder')}
        value={checkInRemark}
        onChange={setCheckInRemark}
      />
    </div>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
